import { render, staticRenderFns } from "./ErWeiMaChaXun.vue?vue&type=template&id=f68e1cfe&scoped=true"
import script from "./ErWeiMaChaXun.vue?vue&type=script&lang=js"
export * from "./ErWeiMaChaXun.vue?vue&type=script&lang=js"
import style0 from "./ErWeiMaChaXun.vue?vue&type=style&index=0&id=f68e1cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68e1cfe",
  null
  
)

export default component.exports